import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Loader2 } from "lucide-react";

const ProtectedAdmin = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0e2a1e] flex items-center justify-center">
        <Loader2 size={40} className="text-[#a4d61e] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!user.is_admin) {
    return (
      <div className="min-h-screen bg-[#0e2a1e] flex flex-col items-center justify-center text-center px-6">
        <h1 className="font-serif-brand text-3xl text-[#f4f2ea]">Not authorized</h1>
        <p className="text-[#f4f2ea]/70 mt-2">The account {user.email} is not on the admin allowlist.</p>
        <a href="/admin/login" className="mt-6 text-[#a4d61e] underline">Try another account</a>
      </div>
    );
  }
  return children;
};

export default ProtectedAdmin;
